// Hosts a visitor passes through on OUR OWN flows — sign-in, OAuth, payment,
// bot checks. Coming back from one of them is the same visit continuing, not
// a new session and not a traffic source (owner, 2026-11-01: sessions arrived
// "from" accounts.google.com and accounts.snapchat.com). One list for the
// session tracker and for attribution, so the two can never disagree.
// The database view uses the same hosts (growth_internal_referrer()).

const HOSTS = [
  /(^|\.)maabar\.io$/,
  /(^|\.)supabase\.co$/,            // Supabase auth redirects
  /^accounts\.google\./,            // Google sign-in
  /^accounts\.snapchat\.com$/,      // Snapchat OAuth
  /^appleid\.apple\.com$/,          // Sign in with Apple
  /^login\.microsoftonline\.com$/,  // Microsoft sign-in
  /^login\.live\.com$/,
  /(^|\.)telr\.com$/,               // Telr hosted payment page (secure.telr.com)
  /^challenges\.cloudflare\.com$/,  // bot check
];

// Facebook is a real traffic source, except its login dialog.
const PATHS = [{ host: /(^|\.)facebook\.com$/, path: /^\/(v[\d.]+\/)?dialog\// }];

// Our own pages a payment or sign-in returns to.
const RETURN_PATHS = [/^\/telr-return/, /^\/telr-app-return/, /^\/auth\/callback/];

export function isInternalReferrer(referrer, ownHost = (typeof window !== 'undefined' ? window.location.hostname : '')) {
  if (!referrer) return false;
  try {
    const u = new URL(referrer);
    const host = u.hostname.toLowerCase();
    if (!host || host === ownHost) return true;
    return HOSTS.some((re) => re.test(host)) || PATHS.some((p) => p.host.test(host) && p.path.test(u.pathname));
  } catch { return false; }
}

export const isReturnPath = (path) => RETURN_PATHS.some((re) => re.test(String(path || '')));

// This page load continues a visit that left for sign-in or payment.
export const isOwnFlowReturn = (referrer, path, ownHost) => (!!referrer && isInternalReferrer(referrer, ownHost)) || isReturnPath(path);
